const easeInOutQuad = ( t, b, c, d ) => {
  t /= d / 2;
  if ( t < 1 ) {
    return c / 2 * t * t + b;
  }
  t--;
  return -c / 2 * ( t * ( t - 2 ) - 1 ) + b;
};

const jumper = () => {

  let element;

  let start;
  let stop;

  let offset;
  let easing;

  let distance;
  let duration;

  let timeStart;
  let timeElapsed;

  let next;

  let callback;

  let frame;

  // scroll position helper
  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper
  function top( element ) {
    return element.getBoundingClientRect().top + start;
  }

  function loop( now ) {

    // store time started if not already started
    if ( !timeStart ) {
      timeStart = now;
    }

    // determine time spent scrolling so far
    timeElapsed = now - timeStart;

    // calculate next scroll position
    next = easing( timeElapsed, start, distance, duration );

    // scroll to it
    window.scrollTo( 0, next );

    // check progress
    timeElapsed < duration
      ? frame = window.requestAnimationFrame( loop )
      : done();
  }

  // scroll finish helper
  function done() {
    // account for rAF rounding inaccuracies
    window.scrollTo( 0, start + distance );

    // fire callback if it exists
    if ( typeof callback === 'function' ) {
      callback();
    }

    // reset timer
    timeStart = false;
  }

  // API
  function jump( target, opts = {} ) {
    // defaults
    duration = opts.duration || 1000;
    offset   = opts.offset   || 0;
    callback = opts.callback || undefined;
    easing   = opts.easing   || easeInOutQuad;

    // cache starting position
    start = location();

    // resolve target
    switch ( typeof target ) {
      case 'number':
        element = undefined;
        stop = start + target;
        break;

      case 'object':
        element = target;
        stop = top( element );
        break;

      case 'string':
        element = document.querySelector( target );
        stop = top( element );
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch ( typeof opts.duration ) {
      case 'number':
        duration = opts.duration;
        break;

      case 'function':
        duration = opts.duration( distance );
        break;
    }

    window.cancelAnimationFrame( frame );
    // start the loop
    frame = window.requestAnimationFrame( loop );

  }
  // expose API
  return jump;

};

const singleton = jumper();

export default singleton;
